import App from '../components/App.jsx'
import {render} from 'react-dom'
import React from 'react'

// init shell
renderApp()

function renderApp() {
console.log('mainApp render start')
  var appElement = document.getElementById('app')
  var config = {
    debug: window.debug,
    qs: {
      cn: window.cn,
      ssId: window.ssId,
      video: window.video,
      animateBg: 0,
      autoPlay: 0,
      bgImage: 'streamspotsplash.jpg',
      bgLink: 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot_splash_player.jpg',
      branding: 1,
      countdown: 1,
      liveOnly: 0,
      playerDescription: 'Default player',
      showBg: 1,
      showMenuCountdown: 1,
      showDesc: 1,
      showDonate: 1,
      showRecentArchives: 1,
      showArchives: 1,
      showRoku: 1,
      showSchedule: 1,
      showSubscribe: 0,
      showThumb: 0,
      showTitle: 1,
      showVenueInfo: 0,
      textColor: 'white',
      thumbImage: null,
      thumbLink: '//cdn2.streamspot.com/streamspot-od-w-circles-160x90'
    },
    byBroadcastor: true,
    disableMenu: true
  }
  render(<App player={config} debug={window.debug}/>, appElement)
  console.log('rendering completed')
}



// WEBPACK FOOTER //
// ./src/external/App.jsx